<template>
    <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
        <b-modal v-model="modalAberto" :title="title" header-bg-variant="secondary" header-text-variant="light"
            @hide="closeModal" centered>
            <b-form @submit.prevent="handleSubmit(cancelar)">
                <b-container>
                    <b-row>
                        <b-col cols="12">
                            <default-form-validation-provider label="Data de cancelamento:">
                                <b-form-datepicker v-model="dtCancelamento" locale="pt-BR"
                                    placeholder="Escolha uma data" class="mb-2" :max="hoje"></b-form-datepicker>
                            </default-form-validation-provider>
                        </b-col>
                        <b-col cols="12">
                            <default-form-validation-provider label="Justificativa de cancelamento:">
                                <b-form-file placeholder="Nenhum arquivo selecionado" v-model="anexoJustificativa"
                                    accept=".pdf"></b-form-file>
                            </default-form-validation-provider>
                        </b-col>
                    </b-row>
                </b-container>
            </b-form>
            <template #modal-footer>
                <b-button size="sm" variant="outline-secondary" @click="closeModal">Sair</b-button>
                <b-button size="sm" variant="secondary" type="submit" @click="handleSubmit(cancelar)"
                    :disabled="!dtCancelamento || !anexoJustificativa">
                    Cancelar concurso
                </b-button>
            </template>
        </b-modal>
    </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import concursoService from "@/services/atos-pessoal/concursoService";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

@Component({
    components: {
        ValidationObserver,
        DefaultFormValidationProvider
    },
})
export default class ModalCancelar extends mixins(UtilsTS, Vue) {
    @Prop({ required: true }) edital!: any;
    @Prop({ required: true }) title!: string;

    modalAberto = true
    dtCancelamento: any = null;
    anexoJustificativa: File | null = null;
    hoje = new Date().toISOString().split("T")[0];

    async cancelar() {
        try {
            const payload = {
                IdEdital: this.edital.IdEdital,
                DtCancelamento: this.dtCancelamento,
                JustificativaCancelamento: this.anexoJustificativa,
            };
            const response = await concursoService.cancelarConcurso(payload)
            if (response) this.$toast.success("Concurso cancelado com sucesso!")
            this.closeModal()
        } catch (error: any) {
            this.tratarError(error)
            console.error("Erro ao cancelar", error);
        } finally {
            this.$emit("reload")
        }
    }

    closeModal() {
        this.$emit("close");
    }
}
</script>